import type { Editor } from ".";
import { RadioGroup } from "@headlessui/react";
import { Controller, useFormContext } from "react-hook-form";
import { Form } from "@/react/components/shared/uikit/Form";
import { Modal } from "@/react/components/shared/uikit/ModalV2";
import { EditorTile } from "./EditorTile";

export const ModalBody = () => {
  const editors: Editor[] = ["visual", "text"];
  const name = "editor";
  const { control } = useFormContext();

  return (
    <Modal.Body>
      <Form.Item name={name} hideLabel hideDescription hideBorder isFirstChild>
        <Controller
          name={name}
          control={control}
          render={({ field: { value, onChange } }) => (
            <RadioGroup
              className="my-5 flex gap-6"
              value={value}
              onChange={onChange}
            >
              {editors.map(editor => (
                <RadioGroup.Option
                  key={editor}
                  value={editor}
                  className="flex-1"
                >
                  {({ checked }) => (
                    <EditorTile tileName={editor} isSelected={checked} />
                  )}
                </RadioGroup.Option>
              ))}
            </RadioGroup>
          )}
        />
      </Form.Item>
    </Modal.Body>
  );
};
